import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { LabelContainer, Slider } from '@motorway/motorway-component-library';

import ExpandableFilter from 'Components/shared/ExpandableFilter/ExpandableFilter';
import { useBreakpoint } from 'Context/BreakpointsContext/BreakpointsContext';
import { applyCypressData } from 'Utilities/helpers';

import useFilterView from './useFilterView';

import styles from './Filters.module.scss';

const SliderFilterView = ({
	clearMax = false,
	disabledFrom = false,
	display,
	filterLabels,
	from = null,
	id,
	increment = 1,
	max,
	min,
	onChange,
	title,
	to = null,
}) => {
	const {
		maxWidth: { breakpointMobile: isMobile },
	} = useBreakpoint();
	const { isExpandableFilter } = useFilterView();

	const sliderProps = {
		clearMax,
		disabledFrom,
		display,
		from,
		increment,
		max,
		min,
		to,
	};

	return (
		<>
			{isExpandableFilter ? (
				<ExpandableFilter
					classNames={{ content: styles.expandableSlider }}
					id={id}
					isDirty={!!from || !!to}
					title={title}
				>
					{() => (
						<div className="sliderWrapper" {...applyCypressData(`${id}Slider`)}>
							<Slider {...sliderProps} onChange={onChange([min, max], filterLabels)} />
						</div>
					)}
				</ExpandableFilter>
			) : (
				<div className="mw-mb-3 mw-mt-3">
					<LabelContainer className={cx('mw-mt-3', { 'mw-mb-2': isMobile, 'mw-mb-3': !isMobile })} label={title} />
					<div className="sliderWrapper" {...applyCypressData(`${id}Slider`)}>
						<Slider sliderClassName="mw-mt-2" {...sliderProps} onChange={onChange([min, max], filterLabels)} />
					</div>
				</div>
			)}
		</>
	);
};

SliderFilterView.propTypes = {
	clearMax: PropTypes.bool,
	disabledFrom: PropTypes.bool,
	display: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
	filterLabels: PropTypes.arrayOf(PropTypes.string).isRequired,
	from: PropTypes.number,
	id: PropTypes.string.isRequired,
	increment: PropTypes.number,
	max: PropTypes.number.isRequired,
	min: PropTypes.number.isRequired,
	onChange: PropTypes.func.isRequired,
	title: PropTypes.node.isRequired,
	to: PropTypes.number,
};

export default SliderFilterView;
